var Backbone = require('backbone');
var User = Backbone.Model.extend({});
export default User;
